export const ACCESS_TOKEN = 'accessToken';
export const ACCESS_TOKEN_EXPIRY = 'accessTokenExpiry';
export const AFFILIATE_ID = 'affiliate_id';
export const USER_PROFILE = 'user_profile';
export const REMEMBER_AUTH = 'remember_auth';
